import PriceLevel from "./PriceLevel"
import { PriceLevelListingStore } from "./PriceLevelListingReducer"

function getStore(state): PriceLevelListingStore {
    return state.priceLevelListingReducer as PriceLevelListingStore
}

export function getPriceLevels(state): PriceLevel[] | undefined {
    return getStore(state).priceLevels.map(p => new PriceLevel(p))
}

export function getPriceLevel(state, priceLevelId: string): PriceLevel | undefined {
    const priceLevel = getStore(state).priceLevels?.find(p => p.id == priceLevelId)
    return priceLevel ? new PriceLevel(priceLevel) : undefined
}



// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevelSelector.ts